export interface ModelOption {
  id: string;
  label: string;
  blurb: string;
}

export const TRANSCRIPTION_MODELS: ModelOption[] = [
  {
    id: 'openai/whisper-large-v3',
    label: 'whisper-large-v3',
    blurb: 'OpenAI · referencia · multilenguaje',
  },
  {
    id: 'x-ai/stt',
    label: 'xAI STT',
    blurb: 'xAI · directo · español',
  },
  {
    id: 'elevenlabs/scribe-v2',
    label: 'Scribe v2',
    blurb: 'ElevenLabs · transcripción multilingüe',
  },
  {
    id: 'google/gemini-3.5-transcribe',
    label: 'Gemini 3.5 Transcribe',
    blurb: 'Google · transcripción de audio',
  },
];

export const SUMMARY_MODELS: ModelOption[] = [
  {
    id: 'google/gemini-3.8-flash',
    label: 'Gemini 3.8 Flash',
    blurb: 'Google · rápido · default',
  },
  {
    id: 'mistralai/mistral-large-4-0',
    label: 'Mistral Large 4.0',
    blurb: 'Mistral · actas y análisis',
  },
  {
    id: 'anthropic/claude-haiku-5.5',
    label: 'Claude Haiku 5.5',
    blurb: 'Anthropic · actas y análisis',
  },
  {
    id: 'z-ai/glm-5.2',
    label: 'glm-5.2',
    blurb: 'Z.ai · contexto largo',
  },
  {
    id: 'deepseek/deepseek-v4.1-flash-1017',
    label: 'DeepSeek V4.1 Flash',
    blurb: 'DeepSeek · costo bajo',
  },
  {
    id: 'minimax/minimax-m3.1-flash:free',
    label: 'MiniMax M3.1 Flash (gratis)',
    blurb: 'MiniMax · gratuito · sujeto a límites de uso',
  },
];

export const DEFAULT_TRANSCRIPTION_MODEL = TRANSCRIPTION_MODELS[0].id;
export const DEFAULT_SUMMARY_MODEL = SUMMARY_MODELS[0].id;

// Solo enviamos parámetros de muestreo a los modelos que los admiten.
export function summarySamplingOptions(model: string): { temperature?: number } {
  return model === 'anthropic/claude-haiku-5.5' ? {} : { temperature: 0.2 };
}

export function transcriptionSamplingOptions(model: string): { temperature?: number } {
  return model === 'openai/whisper-large-v3' ? { temperature: 0 } : {};
}

export function formatModelLabel(modelId: string): string {
  const known = [...TRANSCRIPTION_MODELS, ...SUMMARY_MODELS].find((model) => model.id === modelId);
  if (known) return known.label;

  const [, modelName = modelId] = modelId.split('/');
  return modelName.replace(/-/g, ' ');
}
